import i18n from 'i18next';
import translations from './translations.json';
import { initReactI18next } from 'react-i18next';

i18n.use(initReactI18next).init({
	resources: translations,
	lng: 'de',
	keySeparator: false,
	interpolation: {
		escapeValue: false,
	},
});

export default i18n;
